<template>
  <div id="container">
    <div>
      <canvas id="the-canvas" style="width: 100%"></canvas >
      <footer class="bar  bar-tab" :style="{'height': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
        <div class="foot" v-if='pdfDoc && pageNum <=1 ' style="margin-left: 40%;">
          <button class='right' v-if="pageNum<pdfDoc.numPages" @click="onNextPage">下一页</button>
        </div>
        <div class="foot" v-else style="margin-left: 30%;">
          <button class='left' v-if="pageNum>1" @click="onPrevPage">上一页</button>
          <button class='right' v-if="pageNum<pdfDoc.numPages" @click="onNextPage">下一页</button>
        </div>
      </footer>

    </div>
    <!-- <div class='pdf-page'> -->

    <!-- </div> -->
  </div>
</template>
<script>
    var PDFJS = require('pdfjs-dist')
    export default {
      data () {
        return {
          pdfDoc: null,
          pageNum: 1,
          pageRendering: false,
          pageNumPending: null,
          scale: 0.9
        }
      },
      created () {
        this.showPDF(this.$route.params.url)
      },
      methods: {
        showPDF (url) {
          let _this = this
          PDFJS.getDocument(url).then(function (pdf) {
            _this.pdfDoc = pdf
            _this.renderPage(1)
          })
        },
        renderPage (num) {
          this.pageRendering = true
          let _this = this
          this.pdfDoc.getPage(num).then(function (page) {
            var viewport = page.getViewport(4)
            let canvas = document.getElementById('the-canvas')
            canvas.height = viewport.height * 1.5
            canvas.width = viewport.width
            canvas.style.height = viewport.height * 0.3 + 'px'
                    // Render PDF page into canvas context
            var renderContext = {
              canvasContext: canvas.getContext('2d'),
              viewport: viewport
            }
            var renderTask = page.render(renderContext)

                    // Wait for rendering to finish
            renderTask.promise.then(function () {
              _this.pageRendering = false
              if (_this.pageNumPending !== null) {
                            // New page rendering is pending
                this.renderPage(_this.pageNumPending)
                _this.pageNumPending = null
              }
            })
          })
        },
        queueRenderPage (num) {
          if (this.pageRendering) {
            this.pageNumPending = num
          } else {
            this.renderPage(num)
          }
        },
        onPrevPage () {
          if (this.pageNum <= 1) {
            return
          }
          this.pageNum--
          this.queueRenderPage(this.pageNum)
        },
        onNextPage () {
          if (this.pageNum >= this.pdfDoc.numPages) {
            return
          }
          this.pageNum++
          this.queueRenderPage(this.pageNum)
        }
      }
    }
</script>

<style scoped>

  .pdf-page {

  }


</style>






// WEBPACK FOOTER //
// PdfPreview.vue?205556fd